<h1 mat-dialog-title>{{ 'friendRequests.addInviteDialog.title' | transloco }}</h1>

<mat-dialog-content>
  <p>{{ 'friendRequests.addInviteDialog.instructions.shareCode' | transloco }}</p>

  <p>
    <strong>{{ 'friendRequests.addInviteDialog.organizationCode' | transloco }}: </strong><br>
    <span style="display: inline-flex; align-items: center; gap: 8px;">
      {{ organizationCode }}
      <button mat-icon-button [cdkCopyToClipboard]="organizationCode" [matTooltip]="'friendRequests.addInviteDialog.copyTooltip' | transloco">
        <mat-icon>content_copy</mat-icon>
      </button>
    </span>
  </p>

  <form [formGroup]="inviteForm" (ngSubmit)="sendFriendRequest()">
    <p>{{ 'friendRequests.addInviteDialog.instructions.enterCode' | transloco }}</p>
    <mat-form-field appearance="outline" class="full-width" style="padding: 8px 0px;">
      <mat-label>{{ 'friendRequests.addInviteDialog.enterOrganizationCode' | transloco }}</mat-label>
      <input matInput name="organizationCode" autocomplete="off" formControlName="inviteCode">
      <mat-error *ngIf="inviteForm.get('inviteCode')?.hasError('required')">
        {{ 'friendRequests.addInviteDialog.validation.required' | transloco }}
      </mat-error>
      <mat-error *ngIf="inviteForm.get('inviteCode')?.hasError('mod97Format')">
        {{ 'friendRequests.addInviteDialog.validation.invalidFormat' | transloco }}
      </mat-error>
      <mat-error *ngIf="inviteForm.get('inviteCode')?.hasError('mod97')">
        {{ 'friendRequests.addInviteDialog.validation.invalid' | transloco }}
      </mat-error>
    </mat-form-field>
    <button mat-raised-button color="primary" type="submit" [disabled]="inviteForm.invalid">
      {{ 'friendRequests.addInviteDialog.sendRequestButton' | transloco }}
    </button>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <span style="flex: 1 1 auto;"></span>
  <button (click)="closeDialog()" mat-raised-button type="button">
    {{ 'common.buttons.close' | transloco }}
  </button>
</mat-dialog-actions>
